import classnames from "classnames";
import dynamic from "next/dynamic";
import Image from "next/legacy/image";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";
import Loadingprogressbar from "@/components/LoadingProgressbar";
import LoginMetaTags from "@/components/MetaTags/LoginMetaTags";
import config from "@/lib/config";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoginForm = dynamic(() => import("@/components/Form/index").then(mod => mod.LoginForm), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/Form/index")]
  }
});

// ログイン画面1
export default function Login() {
  const {
    0: isSignupClicked,
    1: setIsSignupClicked
  } = useState(false);
  const clear = useCallback(() => {
    setIsSignupClicked(false);
  }, []);
  useEffect(() => {
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        clear();
      }
    });
    return () => {
      window.removeEventListener("pageshow", clear);
      clear();
    };
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoginMetaTags, {}), !isSignupClicked && /*#__PURE__*/_jsxs("div", {
      className: classnames(processStyles.container, processStyles.login),
      children: [/*#__PURE__*/_jsx("h2", {
        className: `${processStyles.heading} ${processStyles.withoutSteps}`,
        style: {
          textAlign: "left"
        },
        children: "\u30ED\u30B0\u30A4\u30F3"
      }), /*#__PURE__*/_jsx("div", {
        className: processStyles.inner,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(LoginForm, {
            setIsSignupClicked: setIsSignupClicked
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: processStyles.caution,
        children: [/*#__PURE__*/_jsxs("h3", {
          children: [/*#__PURE__*/_jsx("span", {
            className: processStyles.iconCaution,
            children: /*#__PURE__*/_jsx(Image, {
              src: "/images/icon_alert.png",
              alt: "icon_alert",
              layout: "responsive",
              width: 16,
              height: 16,
              unoptimized: true,
              priority: true
            })
          }), "\u3054\u6CE8\u610F"]
        }), /*#__PURE__*/_jsxs("p", {
          children: ["\u30FBMy\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3092\u304A\u6301\u3061\u3060\u3063\u305F\u65B9\u306F\u3001\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u306E\u65B0\u898F\u767B\u9332\u306F\u3067\u304D\u307E\u305B\u3093\u3002", /*#__PURE__*/_jsx(Link, {
            href: config.idc.mySkpCooperation,
            className: "mainColor underline",
            children: "\u3053\u3061\u3089\u304B\u3089"
          }), "\u304A\u624B\u7D9A\u304D\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"]
        }), /*#__PURE__*/_jsx("p", {
          children: "\u30FBSPOOX ID\u3092\u304A\u6301\u3061\u3060\u3063\u305F\u65B9\u306F\u30012026\u5E748\u670831\u65E5\u307E\u3067\u306B\u304A\u624B\u7D9A\u304D\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002\u304A\u624B\u7D9A\u304D\u5B8C\u4E86\u3044\u305F\u3060\u3051\u306A\u3044\u5834\u5408\u306F\u3001\u904E\u53BB\u3054\u767B\u9332\u3044\u305F\u3060\u3044\u305F\u60C5\u5831\u304C\u524A\u9664\u3055\u308C\u307E\u3059\u3002"
        })]
      })]
    }), isSignupClicked && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Loadingprogressbar, {
        fixed: true
      })
    })]
  });
}
Login.layout = "NoHeaderLayout";